const fillInFormItemTypes = {
  new: "new",
  view: "view",
  edit: "edit",
};

export default fillInFormItemTypes;
